import React from "react";
import PropTypes from "prop-types";
import { clx } from "../../../utils/Helpers";
import "./UIInfoRow.scss";

const UIInfoRow = ({
  label,
  value,
  emptyValue,
  className,
  valueClassName,
  ltr,
  children,
}) => (
  <div className={clx("ui-info-row", className)}>
    {label ? <span className="ui-info-row__label">{label}</span> : null}
    <div
      className={clx("ui-info-row__value", valueClassName)}
      dir={ltr ? "ltr" : undefined}
    >
      {children ?? value ?? emptyValue}
    </div>
  </div>
);

UIInfoRow.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  emptyValue: PropTypes.node,
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  ltr: PropTypes.bool,
  children: PropTypes.node,
};

UIInfoRow.defaultProps = {
  label: null,
  value: null,
  emptyValue: "—",
  className: "",
  valueClassName: "",
  ltr: false,
  children: null,
};

export default UIInfoRow;
